<!-- Banner (介绍页顶部banner)：2020/3/12 Sunanguang-->
<template>
  <el-carousel class="its-banners" :height="height" :arrow="carouselSet.arrow" :indicator-position="showIndicator">
      <el-carousel-item class="its-banner" v-for="(banner,i) in banners" :key="i">
        <img class="its-background" :src="getSrc(banner.key)">
        <ts-page-layout center>
          <div class="its-banner-left">
            <div v-if="banner.mainTitle" class="its-main-title" v-html="banner.mainTitle"></div>
            <div v-if="banner.subTitle" class="its-sub-title">{{banner.subTitle}}</div>
            <div v-if="banner.desc" class="its-desc-title" v-html="banner.desc"></div>
            <div type="primary" @click="toDetial('/apply/submit')" class="its-button its-btn-apply">
              <span>立即试用</span>
            </div>
            <div type="primary" @click="toDetial('/eclass/download?tab=1')" class="its-button its-btn-download">
              <span>下载e课堂教师电脑端</span>
            </div>
          </div>
          <div class="its-banner-right">
            <div class="its-video">
              <play-view ref="playViewRef" :item="banner"></play-view>
            </div>
          </div>
          <slot></slot>
        </ts-page-layout>
      </el-carousel-item>
    </el-carousel>
</template>
<script>
import PlayView from '../../../components/PlayView'
export default {
  name:'Banner',
  components: {
    PlayView
  },
  props:{
    height:{
      type:String,
      default:function(){
        return '700px'
      }
    },
    banners:{//banner列表
      type:Array,
      default:function(){
        return []
      }
    },
    carouselSet:{
      type:Object,
      default:function(){
        return {
          arrow:'never',//箭头显示
        }
      }
    }
  },
  data(){
    return {
      showIndicator:'outside'
    }
  },
  mounted(){
    if(this.banners.length==1){
      this.showIndicator = 'none'
    }
  },
  methods:{
    toDetial:function(url){
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.$router.push(url)
    },
    getSrc: function (key) {
      return require('@/assets/images/home/index_banner' + key + '.png')
    },
  }
}
</script>
<style scoped>
.its-banners{
  height: auto;
  position: relative;
  z-index: 1;
}

.its-background{
  height: 786px;
  width: 100%;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  position: absolute;
}

.its-banner-left {
  float: left;
  margin-top: 222px;
  position: relative;
}

.its-banner-right {
  float: right;
  margin-top: 229px;
  position: relative;
}

.its-main-title{
  font-size: 36px;
  color: white;
  font-weight: bold;
}

.its-sub-title{
  font-size: 30px;
  color: white;
  margin-top: 16px;
}

.its-desc-title{
  font-size: 18px;
  color: white;
  line-height: 2;
  margin-top: 19px;
}

.its-button{
  border-radius: 24px;
  text-align: center;
  line-height: 52px;
  cursor: pointer;
  height: 48px;
  line-height: 48px;
  border: 1px solid white;
  float: left;
  font-size: 20px;
  color: white;
  margin-top: 34px;
}

.its-btn-apply{
  width: 180px;
}

.its-btn-download {
  width: 278px;
  margin-left: 18px;
}

.its-button:hover {
  background-color: white;
  color: #588BF6;
}

.its-video {
  width: 634px;
  height: 421px;
  background-image: url(../../../../assets/images/home/computer.png);
  padding: 27px 30px 0 30px;
}

.its-video >>> .ts-ali-player {
  width: 575px !important;
  height: 267px !important;
}

.its-video >>> .ts-ali-player .ts-cover-btn,
.its-video >>> .prism-player .prism-big-play-btn {
  width: 84px !important;
  height: 84px !important;
  left: 50% !important;
  top: 50% !important;
  margin-left: -42px !important;
  margin-top: -42px !important;
  background: url(../../../../assets/images/home/play.png) no-repeat !important;
}

.its-video >>> .prism-player .prism-big-play-btn .outter {
  display: none;
}

</style>
